module.exports = __webpack_public_path__ + "media/images/application/template/video-not-allowed-b97228c245fed60fa5e10deea5cf430b.jpg";